import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Lets a tab page render its action buttons (Refresh / Create / Upload / ...)
 * into the shared row next to the Rollouts / Packages / Groups tabs, instead of
 * a separate row below them. The host (software-update page) provides the target
 * node; each page wraps its buttons in <HeaderActions>.
 */
const HeaderActionsContext = createContext<HTMLElement | null>(null);

export function HeaderActionsHost({
  node,
  children,
}: {
  node: HTMLElement | null;
  children: ReactNode;
}) {
  return <HeaderActionsContext.Provider value={node}>{children}</HeaderActionsContext.Provider>;
}

export function HeaderActions({ children }: { children: ReactNode }) {
  const node = useContext(HeaderActionsContext);
  if (!node) return null;
  return createPortal(children, node);
}
